import React, { FC, useCallback } from "react";
import {
  ContentWrapper,
  Heading,
} from "containers/RightPanel/RightPanel.styles";
import { ButtonColor, ButtonType, ButtonVariant } from "enums/Button";
import { Map } from "immutable";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import styled from "styled-components";
import { OpenRightPanel } from "types/common/rightPanel";
import {
  ButtonsWrapper,
  Content,
} from "../../../../components/Addresses/components/AddressForm.styles";
import Button from "../../../../components/Button/Button";
import {
  deleteShopifyProfile,
  getShopifyProfiles,
} from "../../../../reduxFolder/reducers/shopifyProfiles";
import {
  closeRightPanel,
  openRightPanel,
} from "../../../../reduxFolder/reducers/rightPanel";
import Input from "../../../../components/Input/Input";
import { toastResponseError } from "../../../../utils/responseMessageHelper";

interface ShopifyProfileViewPanelProps {
  panelData: any;
  isOpen: boolean;
  closeRightPanel: () => void;
  openRightPanel: OpenRightPanel;
  deleteShopifyProfile: (data: { id: number }) => Promise<any>;
  getShopifyProfiles: () => void;
}

const ShopifyProfileViewPanel: FC<ShopifyProfileViewPanelProps> = ({
  panelData,
  closeRightPanel,
  openRightPanel,
  deleteShopifyProfile,
  getShopifyProfiles,
}) => {
  const { t } = useTranslation("common");
  const profile = panelData.get("profile");

  const handleEdit = useCallback(() => {
    openRightPanel("SHOPIFY_PROFILE_FORM", Map({ profile }));
  }, [openRightPanel, profile]);

  const handleDelete = useCallback(() => {
    if (window.confirm(t("shopify.deleteConfirmation"))) {
      deleteShopifyProfile({ id: profile.get("id") })
        .then(() => {
          closeRightPanel();
          getShopifyProfiles();
        })
        .catch(toastResponseError);
    }
  }, [deleteShopifyProfile, profile, closeRightPanel, getShopifyProfiles, t]);

  return (
    <ContentWrapper>
      <Heading>{t("shopify.viewProfile")}</Heading>
      <ViewContent>
        <Input
          label={t("shopify.storeName")}
          value={profile.get("store_name")}
          disabled
        />
        <Input
          label={t("shopify.apiSecretKey")}
          value={profile.get("api_secret_key")}
          disabled
        />
        <Input
          label={t("shopify.adminApiAccessToken")}
          value={profile.get("admin_api_access_token")}
          disabled
        />
        <Input
          label={t("shopify.locationId")}
          value={profile.get("location_id")}
          disabled
        />
      </ViewContent>
      <ButtonsWrapper>
        <Button
          onClick={handleEdit}
          variant={ButtonVariant.Bordered}
          color={ButtonColor.Neutral}
        >
          {t("shopify.editProfile")}
        </Button>
        <Button onClick={handleDelete} color={ButtonColor.Danger}>
          {t("shopify.deleteProfile")}
        </Button>
      </ButtonsWrapper>
    </ContentWrapper>
  );
};

const withConnect = connect(null, {
  closeRightPanel,
  openRightPanel,
  deleteShopifyProfile,
  getShopifyProfiles,
});

export default withConnect(ShopifyProfileViewPanel);

const ViewContent = styled(Content)`
  label {
    margin-bottom: 10px;
  }
`;
